import { CreateVideoType } from 'constant/videoTypes'
import React from 'react'
import useTranslation from '../../../../hooks/useTranslation'

export const ProductNotice = (props: any) => {
  const { createVideoType } = props
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-[10px] min-h-[101px] p-4 bg-[#FFF3F3] rounded-lg w-full mt-6">
      <p className="font-bold ">{t('productVideoEditor.productNotice.title')}</p>
      <p className="text-left">
        ⏱️{' '}
        <span className="font-bold text-error">
          {createVideoType === CreateVideoType.PRODUCT_LONG ? t('productVideoEditor.productNotice.perProduct') : t('productVideoEditor.productNotice.product')}{' '}
          {t('productVideoEditor.productNotice.maxDuration')}
        </span>
        , {t('productVideoEditor.productNotice.selectedOrder')} <span className="font-bold text-error">{t('productVideoEditor.productNotice.arrangement')}</span>
        {t('productVideoEditor.productNotice.videoCreation')} <br />
        {t('productVideoEditor.productNotice.trimWarning')}
      </p>
    </div>
  )
}
